import React from 'react';
import { Kicker, CharReveal } from './ui';
const SERVICES = [{
  n: '.01',
  title: 'Brand Identity',
  desc: 'A brand is the story people repeat when you leave the room. We make it worth repeating: strategy, naming, identity systems and guidelines built to survive real use.',
  tags: ['Strategy', 'Naming', 'Identity systems', 'Guidelines'],
  bg: '#17161a'
}, {
  n: '.02',
  title: 'Web Design & Dev',
  desc: 'Sites that load fast, read clean and convert. Designed in the open, built on modern stacks, handed over with documentation your team can actually use.',
  tags: ['UX & UI', 'Development', 'CMS builds', 'SEO foundations'],
  bg: '#1b1a1f'
}, {
  n: '.03',
  title: 'Motion & Content',
  desc: 'Launch films, social systems, edit and sound. Motion is where a brand proves it has a pulse, so we treat every frame like it is going on a billboard.',
  tags: ['Launch films', 'Social systems', 'Edit & sound', 'Podcast production'],
  bg: '#1f1e24'
}, {
  n: '.04',
  title: 'Product Design',
  desc: 'Interfaces people stop noticing because they just work. Research, flows, design systems and prototypes that ship, not decks that gather dust.',
  tags: ['Research', 'Flows', 'Design systems', 'Prototypes'],
  bg: '#242229'
}];
export function Services() {
  return <section id="services" className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32" data-id="element-155">
      <Kicker ig="Ọ́rụ Anyị" en="What we do" data-id="element-156" />
      <h2 className="font-display uppercase text-5xl md:text-8xl tracking-tight mt-4" data-id="element-157">
        <CharReveal text="Services" data-id="element-158" />
      </h2>

      <div className="mt-12 md:mt-16 flex flex-col gap-6" data-id="element-159">
        {SERVICES.map((s, i) => <div key={s.n} className="sticky rounded-2xl border p-7 md:p-14" style={{
        top: `${88 + i * 22}px`,
        background: s.bg,
        borderColor: 'var(--line)',
        boxShadow: '0 -18px 40px rgba(0,0,0,0.35)'
      }} data-id="element-160">
            <div className="grid gap-6 md:grid-cols-12 md:gap-8" data-id="element-161">
              <div className="md:col-span-2" data-id="element-162">
                <span className="font-display text-outline text-4xl md:text-6xl" data-id="element-163">{s.n}</span>
              </div>
              <div className="md:col-span-7" data-id="element-164">
                <h3 className="font-display uppercase text-3xl md:text-5xl tracking-tight" data-id="element-165">{s.title}</h3>
                <p className="mt-4 md:mt-6 max-w-xl text-base md:text-lg leading-relaxed" style={{
              color: 'var(--paper-dim)'
            }} data-id="element-166">
                  {s.desc}
                </p>
                <div className="mt-6 flex flex-wrap gap-2.5" data-id="element-167">
                  {s.tags.map(t => <span key={t} className="font-monoui text-[10px] md:text-[11px] uppercase tracking-[0.14em] rounded-full border px-3.5 py-1.5" style={{
                borderColor: 'var(--line)'
              }} data-id="element-168">
                      {t}
                    </span>)}
                </div>
              </div>
              <div className="md:col-span-3 flex md:justify-end items-start" data-id="element-169">
                <a href="#contact" aria-label={`Start a ${s.title} project`} className="group flex h-14 w-14 md:h-20 md:w-20 items-center justify-center rounded-full transition-transform hover:scale-110 hover:rotate-45" style={{
              background: 'var(--danfo)',
              color: 'var(--ink)'
            }} data-id="element-170">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true" data-id="element-171">
                    <path d="M7 17L17 7M17 7H8M17 7V16" stroke="currentColor" strokeWidth="2.4" strokeLinecap="square" data-id="element-172" />
                  </svg>
                </a>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}